import * as React from 'react';
import {Helmet} from 'react-helmet';
import Container from 'containers/Container';
import Header from 'components/Header';
import HeaderSearch from 'components/HeaderSearch';
import ButtonLink from 'components/ButtonLink';
import {ButtonVariant} from 'components/Button';
import {useRoute} from 'react-router5';
import {IngredientObject} from '../../api/ingredient/types';
import {getIngredients} from '../../api/ingredient/requests';
import validateResponse from '../../helpers/validate-response';
import isError from '../../helpers/isError';
import {IngredientCard} from '../../components/IngredientCard';
import InfiniteScroll from 'react-infinite-scroller';
import styled from 'styled-components';

export const PageContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
`;

/**
 * The ingredients page.
 * @return {React.ReactElement}
 * @constructor
 */
export default function IngredientsPage(): React.ReactElement {
  const {route: {params}} = useRoute();

  const [
    ingredients, setIngredients,
  ] = React.useState<IngredientObject[]>([]);

  const [
    hasMore, loadMore,
  ] = React.useState<boolean>(true);

  React.useEffect(() => {
    fetchIngredients(0);
  }, [params.search]);

  /**
   * Fetch ingredients in the store.
   * @param {number} page
   * @param {number} limit
   */
  function fetchIngredients(page: number, limit: number = 100): void {
    getIngredients({
      title: params.search,
      skip: String(page * limit),
      limit: String(limit),
    }).then((response) => {
      validateResponse(response);
      if (response && !isError(response)) {
        if (response.length === 0) {
          loadMore(false);
          return;
        }

        if (page === 0) {
          setIngredients(response);
          return;
        }

        setIngredients([
          ...ingredients,
          ...response,
        ]);
      }
    });
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Ингредиенты</title>
      </Helmet>
      <PageContentContainer>
        <Header>
          <HeaderSearch
            inputSearch={{
              placeholder: 'Введите название ингредиента',
            }}
            renderAfter={(
              <ButtonLink href="/ingredients/create" variant={ButtonVariant.Primary}>
                Создать ингредиент
              </ButtonLink>
            )}
          />
        </Header>
        <Container>
          <InfiniteScroll
            loadMore={(page) => fetchIngredients(page - 1)}
            hasMore={hasMore}
          >
            {ingredients.map((ingredient) => (
              <IngredientCard
                key={ingredient.id}
                title={ingredient.title}
                energy={ingredient.energy}
              />
            ))}
          </InfiniteScroll>
        </Container>
      </PageContentContainer>
    </React.Fragment>
  );
}
